module.exports = __webpack_public_path__ + "static/media/COLA2018001.8614a7b3.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/PDFFiles/COLA2018001.pdf
// module id = 2264
// module chunks = 1